module.exports = __webpack_public_path__ + "assets/img/website-logo_111.92aa9a44.png";